module.exports = __webpack_public_path__ + "img/0-1.79664827.png";